<template>
  <div class="video-container">
    <div v-if="isLogin && isclickedPlay" id="video" class="video-con-l por small"></div>
    <div class="video-con-l por small" v-else>
      <img :src="item.bigimagehttpurl" alt="" class="pic" />
      <div class="video-con-l-con poa txt-overflow">
        <img
          src="../assets/images/player.png"
          alt=""
          class="player small"
          @click="play()"
        />
        <span>{{ item.videoTitle }}</span>
      </div>
    </div>
		<div id="video" class="video-con-l small por" style="width: 458.54px; height: 267px;" v-if="false">
			<img v-if="!isLogin || !isclickedPlay" :src="item.bigimagehttpurl" alt="" class="pic" />
      <div v-if="!isLogin || !isclickedPlay" class="video-con-l-con poa txt-overflow">
        <img
          src="../assets/images/player.png"
          alt=""
          class="player small"
          @click="play()"
        />
        <span>{{ item.videoTitle }}</span>
      </div>
		</div>
  </div>
</template>
<script>
export default {
  props: ["downloadUrl", "isHome", "isSYKT"],
  data() {
    return {
      myPlayer: null,
      time: "", //视频当前播放的时间
      item: {},
      isLogin: false,
      isclickedPlay: false,
    };
  },
  created() {
    // this.setCookie("admin");
    let user_name = this.getCookie("user_name");
    this.isLogin = !!user_name;
  },
  methods: {
    play() {
      this.isclickedPlay = true;
      if (!this.isLogin) return this.$message.warning("请登录后观看！");
			else this.loadCKplayer(this.item)
    },
    // uggBJ9nqOmVQCBUp5Wt5U
    //视频播放插件
    loadCKplayer(item) {
      let videoObject = {
        platformId: "uggBJ9nqOmVQCBUp5Wt5U", //平台注册码 (分测试、正式)
        container: "#video", //容器的ID或className
        // poster: item.bigimagehttpurl,
        loop: false, //播放结束是否循环播放
        autoplay: false, //是否自动播放(由于个别浏览器问题，设置自动播放时，需手动开启音量)
        // seek: 3, //默认跳转的时间
        mediaId: item.videoMediaID,
        debug: true, //是否开启调试模式
        env: "pro",
        mobileCkControls: true, //是否在移动端（包括ios）环境中显示控制栏
        config: {
          playbackRate: true,
          definition: true,
        },
        style: {
          logo: {
            file: "",
          },
        },
      };
      this.myPlayer = new ckplayer(videoObject);
    },
    changeMedia(item) {
      this.item = item;
      this.isclickedPlay = false;
			if(this.myPlayer) {
				this.myPlayer.dispose()
				this.myPlayer = null
			}
    },
    //获取cookie值
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      // console.log(document.cookie);
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    //存储cookie值
    setCookie(name, exdate) {
      // 设置cookie
      var exDate = new Date();
      exDate.setTime = exDate.getTime() + 24 * 60 * 60 * 1000 * exdate; // cookie 保存十天
      // 字符串拼接cookie
      window.document.cookie = "user_name=" + name;
    },
    loadHandler(player) {
      player.addListener("error", this.errorHandler()); //监听视频加载出错
      player.addListener("loadedmetadata", this.loadedMetaDataHandler()); //监听元数据
      player.addListener("duration", this.durationHandler()); //监听播放时间
      player.addListener("time", this.timeHandler()); //监听播放时间
      player.addListener("play", this.playHandler()); //监听播放
      player.addListener("pause", this.pauseHandler()); //监听暂停播放
      player.addListener("buffer", this.bufferHandler()); //监听缓冲状态
      player.addListener("seek", this.seekHandler()); //监听跳转播放完成
      player.addListener("seekTime", this.seekTimeHandler()); //监听跳转播放完成
      player.addListener("volume", this.volumeChangeHandler()); //监听音量改变
      player.addListener("full", this.fullHandler()); //监听全屏/非全屏切换
      player.addListener("ended", this.endedHandler()); //监听播放结束
      player.addListener("screenshot", this.screenshotHandler()); //监听截图功能
      player.addListener("mouse", this.mouseHandler()); //监听鼠标坐标
      player.addListener("controlBar", this.controlBarHandler()); //监听控制栏显示隐藏事件
      player.addListener("clickEvent", this.clickEventHandler()); //监听点击事件
      player.addListener("videoClick", this.videoClickHandler()); //监听播放器单击事件
      player.addListener("definitionChange", this.definitionChangeHandler()); //监听清晰度切换事件
      player.addListener("loadTime", this.loadTimeHandler()); //监听加载速度
    },
    videoClickHandler(obj) {
      // console.log(obj);
    },
    errorHandler() {
      this.changeText(
        "playerstate",
        "状态：视频加载错误，停止执行其它动作，等待其它操作"
      );
    },

    loadedMetaDataHandler() {
      var metaData = player.getMetaDate();
      var html = "";
      if (parseInt(metaData["videoWidth"]) > 0) {
        this.changeText(
          "playerstate",
          "状态：获取到元数据信息，如果数据错误，可以使用延迟获取"
        );
        html += "总时间：" + metaData["duration"] + "秒，";
        html += "音量：" + metaData["volume"] + "（范围0-1），";
        html += "播放器的宽度：" + metaData["width"] + "px，";
        html += "播放器的高度：" + metaData["height"] + "px，";
        html += "视频宽度：" + metaData["videoWidth"] + "px，";
        html += "视频高度：" + metaData["videoHeight"] + "px，";
        html += "视频原始宽度：" + metaData["streamWidth"] + "px，";
        html += "视频原始高度：" + metaData["streamHeight"] + "px，";
        html += "是否暂停状态：" + metaData["paused"] + "，";
        html += "已加载时间：" + metaData["loadTime"] + "秒，";
        html += "版本号：" + metaData["version"];
      } else {
        this.changeText("playerstate", "状态：未正确获取到元数据信息");
        html = "没有获取到元数据";
      }
      this.changeText("metadata", html);
    },
    playHandler() {
      this.changeText("playstate", +"播放状态： 播放");
      window.setTimeout(function () {
        loadedMetaDataHandler();
      }, 1000);
      loadedMetaDataHandler();
    },

    pauseHandler() {
      //player.animatePause();//暂停所有弹幕
      this.changeText("playstate", "播放状态： 暂停");
      loadedMetaDataHandler();
    },

    timeHandler(time) {
      this.changeText("currenttimestate", "当前播放时间（秒）：" + time);
    },

    durationHandler(duration) {
      this.changeText("duration", "总时间（秒）：" + duration);
    },
    seekHandler(state) {
      this.changeText("seekstate", "跳转状态:" + state);
    },

    seekTimeHandler(time) {
      this.changeText("seekstate", " seekTime:" + time);
    },

    bufferHandler(buffer) {
      this.changeText("bufferstate", "缓冲：" + buffer);
    },

    volumeChangeHandler(vol) {
      this.changeText("volumechangestate", "当前音量：" + vol);
    },
    loadTimeHandler(t) {
      this.changeText("loadtime", "当前加载的时间：" + t);
    },
    screenshotHandler(obj) {
      this.changeText(
        "screenshot",
        "图片名称：" +
          obj["name"] +
          ",截图对象：" +
          obj["object"] +
          ",是否用户保存：" +
          obj["save"] +
          ',图片：<img src="' +
          obj["base64"] +
          '">'
      );
    },

    fullHandler(b) {
      if (b) {
        html = " 全屏";
      } else {
        html = " 否";
      }
      this.changeText("fullstate", html);
    },

    endedHandler() {
      this.changeText("endedstate", "播放结束");
    },

    mouseHandler(obj) {
      this.changeText("mouse", "鼠标位置，x：" + obj["x"] + "，y：" + obj["y"]);
    },

    controlBarHandler(show) {
      if (show) {
        html = " 显示";
      } else {
        html = " 隐藏";
      }
      this.changeText("controlBar", html);
    },
    clickEventHandler(eve) {
      this.changeText("clickEvent", eve);
    },
    definitionChangeHandler(num) {
      this.changeText("definitionChange", "切换清晰度编号" + num);
    },

    deletePlayer() {
      if (player) {
        player.dispose();
        player = null;
      }
    },

    changeText(div, text) {
      document.getElementsByClassName(div)[0].innerHTML = text;
    },

    newVideo() {
      var mediaId = player.getByElement(".mediaId").value;
      if (player == null) {
        return;
      }
      player.changeMediaId(mediaId);
    },
  },
};
</script>
<style lang="scss">
.video-con-l {
  width: 519px;
  height: 295px;
  display: block;
  cursor: pointer;
  &.small {
    width: 458.54px;
    height: 267px;
  }
  &.big {
    width: 637px;
    height: 477px;
  }
  .pic {
    width: 100%;
    height: 100%;
  }
  .player {
		width: 28px;
		height: 28px;
		margin-right: 15px;
		vertical-align: middle;
		display: inline-block;
  }
  .video-con-l-con {
    color: #fff;
    bottom: 0;
    height: 44px;
    line-height: 40px;
    width: 100%;
    padding: 0 18px;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      z-index: 0;
      top: 0;
      background: linear-gradient(transparent,#000);
      bottom: 0;
    }
    img,
    span {
      position: relative;
      z-index: 1;
    }
    .name {
      font-size: 15px;
      width: 80%;
      padding-left: 18px;
    }
    .time {
      font-size: 15px;
      padding-right: 9px;
    }
  }
}
</style>